import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	titleDatabase: {
		id: 'prompt-competitor-link.prompt-database.title-database',
		defaultMessage: 'Try Confluence databases',
		description: 'Popup title to bring awareness to the databases feature',
	},
	descriptionDefaultDatabase: {
		id: 'prompt-competitor-link.prompt-database.description-default-database',
		defaultMessage:
			'To organize content and data without switching tools, try Confluence databases.',
		description:
			'Context which explains that databases are a better alternative to the detected competitor as it keeps all work within Confluence.',
	},
	createButtonDefaultDatabase: {
		id: 'prompt-competitor-link.prompt-database.create-button-default-database',
		defaultMessage: 'Create a database',
		description: 'Button to create and redirect the user to a new database',
	},
	dismissButtonDatabase: {
		id: 'prompt-competitor-link.prompt-database.dismiss-button',
		defaultMessage: 'Do not show databases again',
		description:
			'Button to close the popup and stop displaying the prompt icon and popup everywhere on the current page and not show it again for databases variant of the prompt',
	},
	databaseIconAltText: {
		id: 'prompt-competitor-link.prompt-database.icon-alt-text',
		defaultMessage: 'Confluence Database',
		description: 'Alternative text for the Confluence Database icon',
	},
	successFlagTitle: {
		id: 'prompt-competitor-link.prompt-database.success-flag-title',
		defaultMessage: 'Database added to content tree',
		description: 'Title for success flag when database is created.',
	},
	successFlagDescription: {
		id: 'prompt-competitor-link.prompt-database.success-flag-description',
		defaultMessage:
			'The database has been created in the tree. Go to the database to move its location or change its permissions.',
		description: 'Description for success flag when database is created.',
	},
	successFlagAction: {
		id: 'prompt-competitor-link.prompt-database.success-flag-action',
		defaultMessage: 'Go to database',
		description: 'Action for success flag when database is created.',
	},
	createdFlagTitle: {
		id: 'prompt-competitor-link.prompt-database.created-flag-title',
		defaultMessage: 'Database successfully created',
		description: 'Title for flag when database is created and user navigates to it.',
	},
	createdFlagDescription: {
		id: 'prompt-competitor-link.prompt-database.created-flag-description',
		defaultMessage: 'This database was created as a child item of the content you were working on.',
		description: 'Description for flag when database is created and user navigates to it.',
	},
	createdFlagAction: {
		id: 'prompt-competitor-link.prompt-database.created-flag-action',
		defaultMessage: 'Go back to previous content',
		description: 'Action for flag when database is created and user navigates to it.',
	},
	defaultErrorFlagTitle: {
		id: 'prompt-competitor-link.prompt-database.default-error-flag-title',
		defaultMessage: 'We’re unable to create right now',
		description: 'Title for error flag when database fails to create.',
	},
	defaultErrorFlagDescription: {
		id: 'prompt-competitor-link.prompt-database.default-error-flag-description',
		defaultMessage:
			'Refresh or wait a few minutes and try again. If this keeps happening, contact support.',
		description: 'Description for error flag when database fails to create.',
	},
});
